var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ob1-popin-modal-visual", {
    class: _vm.popinClassName,
    attrs: {
      id: _vm.popinModal.id,
      "aria-labelledby": _vm.popinModal.label,
      "show-close-button": _vm.popinModal.showCloseButton,
    },
    scopedSlots: _vm._u([
      {
        key: "visual",
        fn: function () {
          return [
            _c("div", { staticClass: "ob1-modal-img" }, [
              _c("div", { staticClass: "image-crop" }, [
                _c("img", {
                  attrs: { src: _vm.visual.src, alt: _vm.visual.alt },
                }),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "section",
              {
                attrs: {
                  "data-titre-page": _vm.pageTitle,
                  "data-type-page": _vm.pageType,
                },
              },
              [
                _c("h4", [_vm._v(_vm._s(_vm.title))]),
                _vm._v(" "),
                _vm.subsidized
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "alert-container alert-container-sm additional-message",
                      },
                      [
                        _c("p", { staticClass: "alert" }, [
                          _c("span", {
                            staticClass: "alert-icon icon-phone-fund-euro",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ob1-alert-title" }, [
                            _vm._v(_vm._s(_vm.textSub)),
                          ]),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.subsidized && _vm.enable4xCb
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "alert-container alert-container-sm additional-message",
                      },
                      [
                        _c("p", { staticClass: "alert" }, [
                          _c("span", {
                            staticClass: "alert-icon icon-four-x-credit-card",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ob1-alert-title" }, [
                            _vm._v(_vm._s(_vm.text4xCb)),
                          ]),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "ob1-modal-footer-visual" }, [
                  _c("div", { staticClass: "row d-flex align-items-end" }, [
                    _c(
                      "div",
                      {
                        staticClass: "order-1 order-md-2 col-12 col-md-6 px-0",
                      },
                      [
                        _vm.withDeviceButtonCta
                          ? _c("generic-button-cta", {
                              attrs: {
                                "dto-from-object": _vm.withDeviceButtonCta,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "order-2 order-md-1 col-12 col-md-6 pt-2",
                      },
                      [
                        _vm.withoutDeviceButtonCta
                          ? _c("generic-button-cta", {
                              attrs: {
                                "dto-from-object": _vm.withoutDeviceButtonCta,
                                "css-classes": "ob1-link pb-0",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }